<div class="row">
    <div class="col-md-4">
        <label>SCAC:</label>
    </div>
    <div class="col-md-6">
        <div>{{carrier ? carrier.scac : ''}}</div>
    </div>
</div>
<div class="row">
    <div class="col-md-4">
        <label>Phone:</label>
    </div>
    <div class="col-md-6">
        <div>{{carrier ? carrier.organizationEntity.phone : ''}}</div>
    </div>
</div>

<div class="row">
    <div class="col-md-4">
        <label>Email:</label>
    </div>
    <div class="col-md-6">
        <div>{{carrier? carrier.organizationEntity.email : ''}}</div>
    </div>
</div>